import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductSectionProductSlider(slider) {
    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            vertical: true,
            dots: false,
            arrows: true,
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1
        }
    );
}

function initShopProductSectionProductMobileSlider(slider)
{
    let mobileSlick = $(slider).not('.slick-initialized').slick({
        vertical: false,
        dots: true,
        arrows: false,
        prevArrow: '<span class="slide-arrow prev">Prev</span>',
        nextArrow: '<span class="slide-arrow next">Next</span>',
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false,
                    autoplay: false,
                    dots: true,
                    dotsClass: 'maier-section-product-visual-mobile-dots'
                }
            }
        ]
    });

    mobileSlick.on('afterChange', function(event, slick, currentSlide) {
        var activeDotEl = $(event.target).find('.maier-section-product-visual-mobile-dots').find('li.slick-active');
        if (activeDotEl.get(0)) {
            activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });
}

function initProductOptionParameterEvents() {
    document.querySelectorAll('.product-option-parameter select').forEach(function (select) {
        select.addEventListener('focus', function () {
            this.size = 5;
        });

        select.addEventListener('blur', function () {
            this.size = 1;
        });

        select.addEventListener('change', function () {
            this.size = 1;
            this.blur();
        });
    });
}

function initMaierSectionProduct() {
    if (null === document.querySelector('.maier-section-product-informations-main-footer-link-list-item')) {
        return;
    }

    let productFooterLinkModal = new Modal({
        'id': 'maier-modal-product-footer-link',
        'create': true,
    });

    new AjaxLink({
        selector: '.maier-section-product-informations-main-footer-link-list-item[data-modal]',
        targetElements: {
            '#maier-modal-product-footer-link > .modal-content .content' : 'main .content'
        },
        isTriggerReplace: false,
        callback: function() {
            productFooterLinkModal.show();
        }
    });
}

function observeShopProductSectionProductSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductSectionProductSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-section-product-visual-aside').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-section-product-visual-aside').forEach(slider => initShopProductSectionProductSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function observeShopProductSectionProductMobileSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductSectionProductMobileSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-section-product-visual-mobile').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-section-product-visual-mobile').forEach(slider => initShopProductSectionProductMobileSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierSectionProduct() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeShopProductSectionProductSlider();
            observeShopProductSectionProductMobileSlider();
            initProductOptionParameterEvents();
            initMaierSectionProduct();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierSectionProduct);
} else {
    setupMaierSectionProduct();
}